module.exports = [{
      plugin: require('/Users/b/Projects/bananapark-website/node_modules/gatsby-plugin-web-font-loader/gatsby-browser'),
      options: {"plugins":[],"google":{"families":["Montserrat","Open Sans"]}},
    },{
      plugin: require('/Users/b/Projects/bananapark-website/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
